import { useContext } from 'react'

import { LoadingStateContext } from './LoadingStateContext'

/**
 * Hook to access the LoadingStateContext.
 * Throws an error if used outside of GlobalLoadingProvider.
 */
export function useLoadingStateContext() {
  const context = useContext(LoadingStateContext)
  if (context === undefined) {
    throw new Error('useLoadingStateContext must be used within a GlobalLoadingProvider')
  }

  return context
}
